import { Autocomplete, AutocompleteValue, createStyles, Grid, makeStyles, Theme } from '@freighthub/silhouette-core'
import { useObserver } from 'mobx-react-lite'
import { FC, useEffect, useState } from 'react'
import { useI18n } from 'utils/localisation'

import { IBillingEntityJSON } from './BillingEntitiesModel'
import { TLegalEntity } from './LegalEntitiesModel'

export const billingEntityTestId = 'billing-entity-dropdown'

export type BillingEntityProps = {
  legalEntity: TLegalEntity
  getBillingEntities: () => Promise<IBillingEntityJSON[]>
  helperText: string | false
  error: boolean
  disabled?: boolean
}

interface AutocompleteOption {
  text: string
  value: string
}

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    billingEntityWarning: {
      color: theme.palette.warning.main,
    },
  })
)

const getLabelByValue = (options: AutocompleteOption[], value: string) => {
  const selectedOption = options.find((option) => option.value === value)
  return selectedOption?.text || ''
}

export const BillingEntity: FC<BillingEntityProps> = ({
  legalEntity,
  getBillingEntities,
  helperText,
  error,
  disabled,
}) => {
  const { translate } = useI18n()
  const [billingEntities, setBillingEntities] = useState([])
  const classes = useStyles()

  useEffect(() => {
    getBillingEntities().then((billingEntitiesResponse) => {
      setBillingEntities(
        // @ts-expect-error TS(2345) FIXME: Argument of type '{ text: string; value: string; }... Remove this comment to see the full error message
        billingEntitiesResponse.map(({ name, billingAddress, _id }) => ({
          text: `${name} - ${billingAddress.countryCode}`,
          value: _id,
        }))
      )
    })
  }, [getBillingEntities])

  return useObserver(() => (
    <Grid xs={12}>
      <Grid xs={12}>
        <Autocomplete
          value={{
            text: getLabelByValue(billingEntities, legalEntity.billingEntityId.value),
          }}
          getOptionSelected={(option) => option.text}
          onChange={(_, billingEntity: AutocompleteValue) => {
            legalEntity.setBillingEntityId(billingEntity?.value as string)
          }}
          options={billingEntities}
          label={translate('directory-billing_entity')}
          TextFieldProps={{
            required: true,
            margin: 'none',
            helperText,
            error,
          }}
          data-testid={billingEntityTestId}
          disabled={disabled}
        />
      </Grid>
      {legalEntity._id && legalEntity.billingEntityId.isDirty && (
        <span className={classes.billingEntityWarning}>{translate('directory-billing_entity_update_warning')}</span>
      )}
    </Grid>
  ))
}
